import React from "react";
import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

const RewardsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-6">
      <div className="max-w-md">
        <div className="flex justify-center mb-4">
          <Sparkles className="text-black w-12 h-12 animate-pulse" />
        </div>
        <h1 className="text-3xl font-bold text-black mb-4">Rewards are coming soon.</h1>
        <p className="text-gray-600 text-sm mb-6 italic">
          You've been earning points.<br />
          Soon, they’ll mean something big.
        </p>
      </div>
    </div>
  );
};

export default RewardsPage;
